export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            手机端吃瓜入口
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            随时随地，打开手机浏览器即可访问黑料吃瓜入口，与桌面端完全同步，畅享移动吃瓜体验
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-500/10 via-background-50 to-accent-500/10 border border-background-200 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-500">
              <i className="ri-smartphone-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">
              黑料吃瓜入口 · 移动端
            </h3>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-md mx-auto">
              无需下载APP，手机浏览器直接访问即可体验全部功能。支持51黑料吃瓜入口、黑料视频在线看等全部模块，
              与桌面端数据实时同步。添加到手机主屏幕，一键直达最新吃瓜内容。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
                <i className="ri-android-line"></i>
                <span>安卓访问入口</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
                <i className="ri-apple-line"></i>
                <span>iOS 访问入口</span>
              </div>
            </div>
            <p className="text-foreground-400 text-xs mt-4">扫描二维码或在浏览器输入网址即可访问</p>
          </div>
        </div>
      </div>
    </section>
  );
}